import React from 'react'
// libs
import styled from 'styled-components'
// components
import PerfectScrollbar from 'react-perfect-scrollbar'

const PerfectScrollbarStyled = styled(props => <PerfectScrollbar {...props} />)<any>`
  .ps__rail-x,
  .ps__rail-y {
    z-index: 1000000;
    position: absolute;
  }
`

export default PerfectScrollbarStyled
